import { DefaultService } from "../DefaultService";

export default class B2BClienteSovisBannerService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env)
    }

    find(id) {
		return this._http.get(`${this._env}/b2b/b2bclientesovis/banner/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
	}

    findAll(situacao = 2, page = 0, limit = 20, ...params) {
        return this._http.get(encodeURI(`${this._env}/b2b/b2bclientesovis/banner/findall.json?page=${page}&limit=${limit}&param=${params}&situacao=${situacao}`), this._headers)
        .then(res => {
            return res.body;
        },
        err => {
            this.handleError(err);
        });
    }

    save(imagem, form) {
        const unifiedData = new FormData();

        if(imagem) {
            unifiedData.append("file", imagem.file);
        }

        unifiedData.append("clienteSovisBanner", new Blob([JSON.stringify(form)],
        {
            type: "application/json"
        }));
        unifiedData.append("clienteSovisBanner", form)

        const requestOptions = {
            method: 'POST',
            headers: Object.assign(this._headers.headers),
            body: unifiedData
        }

        delete requestOptions.headers["Content-Type"];
        
		return this._http.post(`${this._env}/b2b/b2bclientesovis/banner`, unifiedData, requestOptions).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    updateSituacao(banner) {
		return this._http.post(`${this._env}/b2b/b2bclientesovis/banner/updatesituacao`, banner, this._headers).then(res => {
			return res.body;
		}, err => {
			this.handleError(err);
		});
    }
}